import { render } from "./Datatable3.vue?vue&type=template&id=7760c04b&ts=true"
import script from "./Datatable3.vue?vue&type=script&lang=ts"
export * from "./Datatable3.vue?vue&type=script&lang=ts"

import "./Datatable3.vue?vue&type=style&index=0&id=7760c04b&lang=scss"

import exportComponent from "/Users/barry/www/my/www/bi/portal-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__